let cachedConfig = null;

function getTradeInConfig() {
    if (cachedConfig) return cachedConfig;

    const tradeInDataScript = document.getElementById('trade-in-data');
    if (!tradeInDataScript) return null;

    try {
        const config = JSON.parse(tradeInDataScript.textContent);
        cachedConfig = {
            currencyCode: config.currencyCode || 'PE',
            tradeInData: config.tradeInProductData || [],
            editText: config.editText || 'edit',
            modalId: config.modalId,
            descriptionTemplate: config.descriptionTemplate || 'Get up to {highest_available_value} for your device'
        };
        return cachedConfig;
    } catch (error) {
        console.error('Error parsing trade-in config:', error);
        return null;
    }
}

function formatTradeInPrice(price, currencyCode = null, isHighestValue = false) {
    if (!price) return '';

    if (!currencyCode) {
        const config = getTradeInConfig();
        currencyCode = config?.currencyCode || 'PE';
    }

    let numericPrice;
    if (typeof price === 'string') {
        const cleanPrice = price.replace(/[^0-9.-]+/g, '');
        numericPrice = parseFloat(cleanPrice) || 0;
    } else {
        numericPrice = parseFloat(price) || 0;
    }

    if (isNaN(numericPrice) || numericPrice <= 0) return '';

    if (isHighestValue) {
        numericPrice = Math.round(numericPrice / 100);
    } else {
        numericPrice = Math.round(numericPrice);
    }

    let currencySymbol = '$';
    if (currencyCode.includes('PE')) {
        currencySymbol = 'S/. ';
    }

    const formattedNumber = numericPrice.toLocaleString('es-CO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true
    });

    return currencySymbol + formattedNumber;
}

function updateTradeInDescriptions() {
    const config = getTradeInConfig();

    if (!config?.tradeInData || !Array.isArray(config.tradeInData)) {
        return;
    }

    const tradeInData = config.tradeInData;
    let highestValue = 0;

    tradeInData.forEach(device => {
        const grades = ['gradeA', 'gradeB', 'gradeC', 'gradeD'];
        grades.forEach(grade => {
            if (device[grade] && device[grade] !== '') {
                const numericValue = parseInt(device[grade].toString().replace(/[^0-9]/g, '')) || 0;
                if (numericValue > highestValue) {
                    highestValue = numericValue;
                }
            }
        });
    });

    if (highestValue > 0) {
        const formattedHighestValue = formatTradeInPrice(highestValue, null, true);

        const modalDescriptions = document.querySelectorAll('[data-modified-description]');
        modalDescriptions.forEach(element => {
            const hasSelectedValue = element.getAttribute('data-trade-in-value') &&
                element.getAttribute('data-trade-in-value') !== '0' &&
                element.getAttribute('data-trade-in-value') !== '';

            if (hasSelectedValue) {
                return;
            }

            const originalText = element.getAttribute('data-modified-description');
            const pdpDescription = document.querySelector('.trade-in__pdp-description');
            if (originalText) {
                let updatedText;
                if (originalText.includes('${{') || originalText.includes('highest_available_value')) {
                    updatedText = originalText.replace(/\$\{\{\s*highest_available_value\s*\}\}/g, formattedHighestValue);
                } else {
                    updatedText = originalText.replace(/\$[\d,.]+(\s+[A-Z]{3})?/g, formattedHighestValue);
                }
                element.textContent = updatedText;
                if (pdpDescription) {
                    pdpDescription.innerText = updatedText;
                }
            }
        });
    }
}

let deviceSearchInstances = new Map();

function initializeDeviceSearch() {
    const searchInputs = document.querySelectorAll('.device-search-input');

    searchInputs.forEach(searchInput => {
        const modalId = searchInput.id.split('-').pop();

        const searchResults = document.getElementById(`device-search-results-${modalId}`);
        const gradeOptions = document.getElementById(`grade-options-${modalId}`);

        const modalContainer = searchInput.closest('.trade-in__modal-content');
        const tradeInValueInput = modalContainer ?
            modalContainer.querySelector('#trade-in-value') :
            document.getElementById('trade-in-value');
        const tradeInDeviceInput = modalContainer ?
            modalContainer.querySelector('#trade-in-device') :
            document.getElementById('trade-in-device');
        const valueAmountSpans = document.querySelectorAll('.js-trade-in-value-amount');

        const addButton = modalContainer ?
            modalContainer.querySelector('.add-to-product, .add-cart-trade-in, .js-add-to-product') :
            document.querySelector('.add-to-product, .add-cart-trade-in, .js-add-to-product');

        if (deviceSearchInstances.has(modalId)) {
            const existingInstance = deviceSearchInstances.get(modalId);
            if (existingInstance.cleanup) {
                existingInstance.cleanup();
            }
        }

        let selectedDevice = null;

        if (tradeInDeviceInput && tradeInDeviceInput.value && tradeInValueInput && tradeInValueInput.value !== '0') {
            const deviceName = tradeInDeviceInput.value;
            const config = getTradeInConfig();
            const deviceData = config?.tradeInData?.find(device => device.model === deviceName);

            if (deviceData) {
                selectedDevice = {
                    model: deviceData.model,
                    vendor: deviceData.vendor || deviceData.brand || '',
                    gradeA: deviceData.gradeA,
                    gradeB: deviceData.gradeB,
                    gradeC: deviceData.gradeC,
                    gradeD: deviceData.gradeD
                };

                if (searchInput) {
                    searchInput.value = selectedDevice.model;
                }
            }
        }

        const inputHandler = function () {
            const query = this.value.toLowerCase();
            const deviceOptions = searchResults.querySelectorAll('.device-option');
            let hasVisibleOptions = false;

            deviceOptions.forEach(option => {
                const searchTerms = option.dataset.searchTerms ? option.dataset.searchTerms.toLowerCase() : '';
                const displayText = option.textContent.toLowerCase();

                const matchesSearchTerms = searchTerms.includes(query);
                const matchesDisplayText = displayText.includes(query);

                if ((matchesSearchTerms || matchesDisplayText) && query.length > 0) {
                    option.style.display = 'block';
                    hasVisibleOptions = true;
                } else {
                    option.style.display = 'none';
                }
            });

            searchResults.style.display = hasVisibleOptions && query.length > 0 ? 'block' : 'none';
        };

        const clickHandler = function (e) {
            if (e.target.classList.contains('device-option')) {
                const clickedModel = e.target.dataset.model;
                const clickedVendor = e.target.dataset.vendor;

                const config = getTradeInConfig();
                const deviceData = config?.tradeInData?.find(device =>
                    device.model === clickedModel &&
                    (device.vendor === clickedVendor || device.brand === clickedVendor)
                );

                if (deviceData) {
                    selectedDevice = {
                        model: deviceData.model,
                        vendor: deviceData.vendor || deviceData.brand || '',
                        gradeA: deviceData.gradeA,
                        gradeB: deviceData.gradeB,
                        gradeC: deviceData.gradeC,
                        gradeD: deviceData.gradeD
                    };

                    searchInput.value = selectedDevice.model;
                    searchResults.style.display = 'none';

                    if (tradeInDeviceInput) {
                        tradeInDeviceInput.value = selectedDevice.model;
                    }
                    updatePrice();
                }
            }
        };

        const documentClickHandler = function (e) {
            if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
                searchResults.style.display = 'none';
            }
        };

        if (searchInput && searchResults) {
            searchInput.addEventListener('input', inputHandler);
            searchResults.addEventListener('click', clickHandler);
            document.addEventListener('click', documentClickHandler);
        }

        const gradeChangeHandler = function (e) {
            if (e.target.type === 'radio') {
                updatePrice();
                const radios = gradeOptions.querySelectorAll('.radio');
                radios.forEach(radio => radio.classList.remove('active'));
                e.target.closest('.radio').classList.add('active');
            }
        };

        if (gradeOptions) {
            gradeOptions.addEventListener('change', gradeChangeHandler);
        }

        function updatePrice() {
            const selectedGrade = gradeOptions ? gradeOptions.querySelector('input[type="radio"]:checked') : null;

            if (!selectedGrade || !selectedDevice) {
                if (addButton) {
                    addButton.setAttribute('disabled', 'disabled');
                }
                return;
            }

            const gradeValue = selectedGrade.value;
            const tradeInPrice = selectedDevice[gradeValue];

            if (addButton) {
                addButton.setAttribute('data-trade-in-device', selectedDevice.model);
                addButton.removeAttribute('disabled');
                addButton.disabled = false;

                if (tradeInPrice) {
                    addButton.setAttribute('data-trade-in-value', tradeInPrice);
                } else {
                    addButton.setAttribute('data-trade-in-value', '0');
                }
            }

            if (tradeInPrice && tradeInValueInput) {
                tradeInValueInput.value = tradeInPrice;

                if (valueAmountSpans && valueAmountSpans.length) {
                    valueAmountSpans.forEach(valueAmountSpan => {
                        const formattedPrice = formatTradeInPrice(tradeInPrice);
                        valueAmountSpan.textContent = formattedPrice;
                        valueAmountSpan.setAttribute('data-trade-in-value', tradeInPrice);
                        valueAmountSpan.parentElement.style.display = 'block';
                    });
                }
            }
        }

        deviceSearchInstances.set(modalId, {
            selectedDevice: () => selectedDevice,
            updatePrice: updatePrice,
            cleanup: () => {
                if (searchInput && searchResults) {
                    searchInput.removeEventListener('input', inputHandler);
                    searchResults.removeEventListener('click', clickHandler);
                    document.removeEventListener('click', documentClickHandler);
                }
                if (gradeOptions) {
                    gradeOptions.removeEventListener('change', gradeChangeHandler);
                }
            }
        });

        if (selectedDevice) {
            updatePrice();
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    updateTradeInDescriptions();
    initializeDeviceSearch();
    initializeTradeInValueAmounts();
});

function initializeTradeInValueAmounts() {
    const valueAmountElements = document.querySelectorAll('.js-trade-in-value-amount');
    valueAmountElements.forEach(element => {
        const rawValue = element.getAttribute('data-trade-in-value');
        if (rawValue && rawValue !== '0') {
            const formattedPrice = formatTradeInPrice(rawValue);
            element.textContent = formattedPrice;
        }
    });
}
